<template>
  <div class="sports-entertainment">
    <PopupHeader title="Sport i relaks" icon="filters" @close="close" :backLeftIcon="true" :closeIcon="false" />
    <CheckList ref="list" class="sports-entertainment__body" v-model="sportsEntertainments" />
    <PopupFooter @select="$emit('input', sportsEntertainments)" @clear="$refs.list.clear()" @selectAll="$refs.list.selectAll()" />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'
import Component from 'vue-class-component'

import PopupFooter from './PopupFooter.vue'
import PopupHeader from './PopupHeader.vue'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import CheckList from '@/components/CheckList.vue'

@Component({
  mixins: [
    AutoCloseMixin,
  ],
  components: {
    CheckList,
    PopupHeader,
    PopupFooter,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
})
export default class SportsEntertainment extends Vue {
  sportsEntertainments = cloneDeep(this.value)
}
</script>

<style lang="scss" scoped>
@import '../mobile-popup.scss';

.sports-entertainment {
  @include mobile-popup(white, #009FEA);

  &__body {
    @include mobile-popup__body(black, white);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/SportsEntertainmentPopup.vue